<ion-app [class.ion-palette-dark]="dark">
  <ion-split-pane contentId="main-content">
    <ion-menu menuId="main-menu" contentId="main-content" swipeGesture="true">
      <ion-content>

        <div class="menu-header">
          <div>
            <img class="profile-card_header-imgbox" src="{{profiledetails.usr_img}}"
              onError="src = '../assets/imgs/logo_splash_txt.png'" alt="No data" imageViewer />
          </div>
          <div style="margin-top: 30px">
            <h6 style="color: #41617d; margin-bottom: 0px">
              {{profiledetails.usr_nm}}
            </h6>
            <h6 style="color: red">
              <span *ngIf="package_name==1">Platinum</span><span *ngIf="package_name==2">Gold</span><span
                *ngIf="package_name==3">Silver</span><span *ngIf="package_name==0">Free</span>
            </h6>

            <p style="color: #41617d; margin-top: 0px">
              <strong>{{profiledetails.usr_ph}}</strong>
            </p>
          </div>
        </div>

        <ion-item-divider class="menu-divider"></ion-item-divider>
        <ion-list lines="none">
          @for (p of appPages; track p.id) {
          <ion-menu-toggle autoHide="false">
            <ion-item [routerLink]="p.url || null" (click)="!p.url && onItemClick(p)" routerLinkActive="selected"
              routerDirection="root" detail="false">
              <ion-img slot="start" [src]="p.icon" class="w-30"></ion-img>
              <ion-label>{{ p.header }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          }
        </ion-list>
        <div id="google_translate_element" style="display:none"></div>



        <ion-item-divider class="menu-divider"></ion-item-divider>


        <ion-list lines="none">
          <ion-menu-toggle autoHide="false">
            <ion-item detail="false">
              <ion-icon slot="start" name="hammer"></ion-icon>
              <ion-label>Version 1.2.0</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>



<div *ngIf="showSplash" class="splash">
  <div>
    <img src="../assets/imgs/splash12.gif" style="height: 854px" />
  </div>
</div>

<!-- Disable swipe-to-go-back because it's poor UX to combine STGB with side menus -->